import { render, staticRenderFns } from "./ApproveFormOaDetail.vue?vue&type=template&id=33f286fa&scoped=true"
import script from "./ApproveFormOaDetail.vue?vue&type=script&lang=js"
export * from "./ApproveFormOaDetail.vue?vue&type=script&lang=js"
import style0 from "./ApproveFormOaDetail.vue?vue&type=style&index=0&id=33f286fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f286fa",
  null
  
)

export default component.exports